import { Form, Input } from "@/atoms"
import { useCustomFunctionsForm } from "@/hooks/useCustomFunctionsForm"

import type { FieldLinkTicketProps } from "./CreateTicketButton.types"

export const FieldLinkTicket = (props: FieldLinkTicketProps) => {
  const { name, t, placeholder } = props
  const { focusRef } = useCustomFunctionsForm()

  return (
    <Form.Item
      name={name}
      validateTrigger="onSubmit"
      rules={[{ required: true, message: t("error.requiredField") }]}
    >
      <Input ref={focusRef} placeholder={placeholder} />
    </Form.Item>
  )
}
